import { render } from "./watch.vue?vue&type=template&id=60a11794&scoped=true"
import script from "./watch.vue?vue&type=script&lang=js"
export * from "./watch.vue?vue&type=script&lang=js"

import "./watch.vue?vue&type=style&index=0&id=60a11794&lang=scss&scoped=true"

import exportComponent from "E:\\My Websites\\v12\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a11794"]])

export default __exports__